module.exports = __webpack_public_path__ + "img/000-Empty.df4f27c6.svg";